<template>
  <div class="bs-docs-section pt-3 mx-3 my-3 page-wrap">
    <div class="blogs-section">
      <div class="row">
        <div class="col-md-12 text-center mb-2 pt-3">
          <h4>Blogs</h4>
          <hr class="w-90" />
        </div>
        <div id="displayBlogs" class="leftcolumn">
          <div
            class="blog-card"
            v-for="(blog, index) in myBlogFeed"
            :key="index"
          >
            <div class="meta">
              <div class="photo">
                <div v-if="blog.thumbnail">
                  <img :src="blog.thumbnail" class="blog-img" />
                </div>
                <div v-else>
                  <img src="../assets/images/Blogs.png" class="blog-img" />
                </div>
              </div>
              <ul class="details">
                <li class="author">
                  <a href="#">{{ blog.author }}</a>
                </li>
                <li class="date">
                  {{ blog.pubDate | moment("MMMM Do YYYY, h:mm:ss a") }}
                </li>
                <li class="tags">
                  <ul>
                    <li v-for="(tag, index) in blog.categories" :key="index">
                      <a href="#">{{ tag }}</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="description">
              <h1>{{ blog.title }}</h1>
              <h2></h2>
              <p>{{ blog.content | stripHtmlTags | trimFunction(200) }}</p>
              <p class="read-more">
                <a :href="blog.link">Read More</a>
              </p>
            </div>
          </div>
        </div>
        <div class="rightcolumn">
          <div class="card">
            <h2>Finult Blogs</h2>
            <div class="fakeimg" style="height: 100px;"></div>
            <p>Good content to tell what we are trying to achieve</p>
          </div>
          <div class="card">
            <h3>Popular Post</h3>
            <div class="fakeimg"></div>
            <br />
            <div class="fakeimg"></div>
            <br />
            <div class="fakeimg"></div>
          </div>
          <div class="card">
            <h3>Some more</h3>
            <p>Some text..</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/finult-pages.css";
import axios from "axios";

export default {
  name: "Blogs",
  metaInfo: {
    title: "Blogs"
  },
  data() {
    return {
      rsstojson: "https://api.rss2json.com/v1/api.json?rss_url=",
      feedURL: "https://avinashholla-blog1.blogspot.com/feeds/posts/default",
      myBlogFeed: []
    };
  },
  created() {
    let rssURL = this.rsstojson + this.feedURL;
    axios
      .get(rssURL)
      .then(feedResponse => {
        console.log(feedResponse);
        this.myBlogFeed = feedResponse.data.items;
      })
      .catch(err => {
        console.log(err);
      });
  }
};
</script>

<style></style>
